export default function init() {
  const lazyImages = document.querySelectorAll('img.lazyload');

  const initLazyLoadingPolyfill = async () => {
    await import(/* webpackChunkName: "image--lazysizes" */ 'lazysizes');
  };

  if (lazyImages.length) initLazyLoadingPolyfill();
}
